import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { SocialProofBar } from '../components/home/SocialProofBar';
import { TodayInSky } from '../components/home/TodayInSky';
import { HowItWorks } from '../components/home/HowItWorks';
import { PopularServices } from '../components/home/PopularServices';
import { WhyAstroGuide } from '../components/home/WhyAstroGuide';
import { PricingSection } from '../components/home/PricingSection';
import { ReportPreviewSection } from '../components/home/ReportPreviewSection';
import { TopAstrologersSection } from '../components/home/TopAstrologersSection';
import { AstroCalendarSection } from '../components/home/AstroCalendarSection';
import { BlogSection } from '../components/home/BlogSection';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { ForAstrologersSection } from '../components/home/ForAstrologersSection';
import { FaqSection } from '../components/home/FaqSection';
import { FinalCtaSection } from '../components/home/FinalCtaSection';
import { SectionErrorBoundary } from '../components/SectionErrorBoundary';
interface HomePageProps {
  onNavigate: (page: string) => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <div className="w-full" data-id="element-22487">
      {/* 1. HERO */}
      <SectionErrorBoundary sectionName="HeroBanner" fallbackMinHeight="min-h-screen" data-id="element-22488">
        <HeroBanner onNavigate={onNavigate} data-id="element-22489" />
      </SectionErrorBoundary>

      {/* 2. SOCIAL PROOF BAR */}
      <SectionErrorBoundary sectionName="SocialProofBar" fallbackMinHeight="min-h-[80px]" data-id="element-22490">
        <SocialProofBar data-id="element-22491" />
      </SectionErrorBoundary>

      {/* 3. СЕГОДНЯ В НЕБЕ */}
      <SectionErrorBoundary sectionName="TodayInSky" data-id="element-22492">
        <TodayInSky onNavigate={onNavigate} data-id="element-22493" />
      </SectionErrorBoundary>

      {/* 4. КАК ЭТО РАБОТАЕТ */}
      <SectionErrorBoundary sectionName="HowItWorks" data-id="element-22494">
        <HowItWorks data-id="element-22495" />
      </SectionErrorBoundary>

      {/* 5. ПОПУЛЯРНЫЕ УСЛУГИ */}
      <SectionErrorBoundary sectionName="PopularServices" data-id="element-22496">
        <PopularServices onNavigate={onNavigate} data-id="element-22497" />
      </SectionErrorBoundary>

      {/* 6. ПОЧЕМУ ASTRIQO */}
      <SectionErrorBoundary sectionName="WhyAstroGuide" data-id="element-22498">
        <WhyAstroGuide data-id="element-22499" />
      </SectionErrorBoundary>

      {/* 7. ТАРИФЫ */}
      <SectionErrorBoundary sectionName="PricingSection" data-id="element-22500">
        <PricingSection onNavigate={onNavigate} data-id="element-22501" />
      </SectionErrorBoundary>

      {/* 8. ПРЕВЬЮ ОТЧЁТА */}
      <SectionErrorBoundary sectionName="ReportPreviewSection" data-id="element-22502">
        <ReportPreviewSection onNavigate={onNavigate} data-id="element-22503" />
      </SectionErrorBoundary>

      {/* 9. ТОП АСТРОЛОГИ */}
      <SectionErrorBoundary sectionName="TopAstrologersSection" data-id="element-22504">
        <TopAstrologersSection onNavigate={onNavigate} data-id="element-22505" />
      </SectionErrorBoundary>

      {/* 10. КАЛЕНДАРЬ */}
      <SectionErrorBoundary sectionName="AstroCalendarSection" data-id="element-22506">
        <AstroCalendarSection onNavigate={onNavigate} data-id="element-22507" />
      </SectionErrorBoundary>

      {/* 11. БЛОГ */}
      <SectionErrorBoundary sectionName="BlogSection" data-id="element-22508">
        <BlogSection onNavigate={onNavigate} data-id="element-22509" />
      </SectionErrorBoundary>

      {/* 12. ОТЗЫВЫ */}
      <SectionErrorBoundary sectionName="ReviewsSection" data-id="element-22510">
        <ReviewsSection data-id="element-22511" />
      </SectionErrorBoundary>

      {/* 13. ДЛЯ АСТРОЛОГОВ */}
      <SectionErrorBoundary sectionName="ForAstrologersSection" data-id="element-22512">
        <ForAstrologersSection onNavigate={onNavigate} data-id="element-22513" />
      </SectionErrorBoundary>

      {/* 14. FAQ */}
      <SectionErrorBoundary sectionName="FaqSection" data-id="element-22514">
        <FaqSection data-id="element-22515" />
      </SectionErrorBoundary>

      {/* 15. ФИНАЛЬНЫЙ CTA */}
      <SectionErrorBoundary sectionName="FinalCtaSection" data-id="element-22516">
        <FinalCtaSection data-id="element-22517" />
      </SectionErrorBoundary>
    </div>;
}